module.exports = __webpack_public_path__ + "img/episode.a24e187a.svg";